import {
    COLOR
} from '../../business-const/Color/Color'

const tipoClassificacaoImcList = [
    {
        id: 10,
        descricao: 'Muito abaixo do peso',
        ordem: 10,
        imcInicial: 1,
        imcFinal: 16.9,
        corDestaque: COLOR().corDestaqueVermelho,
    },
    {
        id: 20,
        descricao: 'Abaixo do peso',
        ordem: 20,
        imcInicial: 17,
        imcFinal: 18.4,
        corDestaque: COLOR().corDestaqueAmarelo,
    },
    {
        id: 30,
        descricao: 'Peso normal',
        ordem: 30,
        imcInicial: 18.5,
        imcFinal: 24.9,
        corDestaque: COLOR().corDestaqueVerde,
    },
    {
        id: 40,
        descricao: 'Acima do peso',
        ordem: 40,
        imcInicial: 25,
        imcFinal: 29.9,
        corDestaque: COLOR().corDestaqueAmarelo,
    },
    {
        id: 50,
        descricao: 'Obesidade Grau I',
        ordem: 50,
        imcInicial: 30,
        imcFinal: 34.9,
        corDestaque: COLOR().corDestaqueLaranja,
    },
    {
        id: 60,
        descricao: 'Obesidade Grau II',
        ordem: 60,
        imcInicial: 35,
        imcFinal: 40,
        corDestaque: COLOR().corDestaqueVermelho,
    },
    {
        id: 70,
        descricao: 'Obesidade Grau III',
        ordem: 70,
        imcInicial: 40.1,
        imcFinal: 999,
        corDestaque: COLOR().corDestaqueVermelho,
    },
]

export default tipoClassificacaoImcList